import gql from 'graphql-tag';

export const ARTICLE_CANDIDATES = gql`
  query ArticleCandidates(
    $campaignId: ID!
    $startDate: String!
    $endDate: String!
    $contentType: String!
    $page: Int!
    $orderBy: String!
    $direction: String!
    $sourceIds: [Int!]
    $searchPhrase: String
  ) {
    articleCandidates(
      campaignId: $campaignId
      startDate: $startDate
      endDate: $endDate
      contentType: $contentType
      page: $page
      orderBy: $orderBy
      direction: $direction
      sourceIds: $sourceIds
      searchPhrase: $searchPhrase
    ) {
      articleId
      hashKey
      title
      url
      publishDate
      articleType
      articleCandidateId
      fullUrl
      isInstantArticle
      languageCode
      likes
      shares
      views
      comments
      organicCtr
      sources
      creatives {
        postId
        source
      }
      fbNonKeyweePv1d
      fbNonKeyweePv7d
      fbNonKeyweePv30d
      paidNonFbPv1d
      paidNonFbPv7d
      paidNonFbPv30d
      pixelDataDate
      pixelPvps30dAvgSessionLength
    }
  }
`;
